<template>
  <base-modal
    :id="modalId"
    :ok-handler="okHandler"
    :title="title"
    :ok-button-text="okButtonText"
    :is-footer="isFooter"
  >
    <div class="duplicate-modal">
      <spinner :show="isLoading" />
      <p>{{ content }}</p>
      <b-table
        id="duplicate-table"
        :fields="fields"
        :items="duplicatesToResolve"
      >
        <template v-slot:cell(resolve)="data">
          <div class="recipient-checkbox">
            <input
              id="data.index"
              v-model="duplicatesToSend[data.item.duplicateId]"
              type="checkbox"
            />
          </div>
        </template>
        <template v-slot:cell(organization)="data">
          {{ data.item.organizationContact }}
          {{ phoneNum(data.item.organizationContactPhone) }}<br />
          <small>{{ data.item.organizationName }}</small>
        </template>
      </b-table>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal';
import transformPhoneNum from '../../util/dataTransformation';
import Spinner from '../Spinner';

export default {
  name: 'DuplicateModal',
  components: { BaseModal, Spinner },
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    okButtonText: {
      type: String,
      default: 'OK',
    },
    okButtonClass: {
      type: String,
      default: '',
    },
    delButtonClass: {
      type: String,
      default: '',
    },
    isFooter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalId: 'duplicate-modal',
      duplicatesToSend: {}, // The list of duplicates that are checked. this may need to be a computed value or a watch value
      isLoading: true,
      fields: [
        {
          key: 'resolve',
          sortable: false,
          class: 'table-info-icon'
        },
        {
          key: 'recipientFirstName',
          label: 'First name',
          sortable: true
        },
        {
          key: 'recipientLastName',
          label: 'Last name',
          sortable: true
        },
        {
          key: 'recipientAddressLine1',
          label: 'Address',
          sortable: false,
        },
        {
          key: 'organization',
          label: 'Organization',
          sortable: false,
        }
      ]
    }
  },
  computed: {
    mainRecip() {
      return this.$store.getters.getDuplicateMain;
    },
    duplicatesToResolve() {
      let filteredDupes;
      if (this.$store.getters.getUser) {
        let dupes = [];
        this.$store.getters.getDuplicatesToResolve.forEach((duplicate) => {
          const modifiedDuplicates = duplicate.duplicates.map(item => {
            item.duplicateId = duplicate.id;
            return item;
          });
          dupes = dupes.concat(modifiedDuplicates);
        });
        filteredDupes = dupes.filter(item => item.recipientId !== this.mainRecip);
        if (filteredDupes.length > 0) { this.disableLoading(); }
        console.log('DUPES: ', filteredDupes);
        console.log('this.mainRecip: ', this.mainRecip);
      }
      return filteredDupes;
    },
    duplicateIdsToResolve: function() {
      return this.$store.getters.getDuplicateIdsToResolve;
    }
  },
  mounted() {
    // HACK: Since modals are mounted immediately, we dont know the ids to use yet so this pushs the API call until the modal is shown
    const handleShow = this.handleShow;
    const handleClose = this.handleClose;
    this.$root.$on('bv::modal::show', handleShow);
    this.$root.$on('bv::modal::hide', handleClose);
  },
  methods: {
    disableLoading() {
      this.isLoading = false;
    },
    handleShow: function(bvModalEvt) {
      this.isLoading = true;
      if (bvModalEvt.componentId === this.modalId) {
        if (this.duplicateIdsToResolve) {
          this.$store.dispatch('getDuplicateInfo', this.duplicateIdsToResolve);
        }
      }
    },
    handleClose: function(bvModalEvt) {
      if (bvModalEvt.componentId === this.modalId) {
        this.$store.dispatch('clearDuplicateState');
        this.duplicatesToSend = {}; // reset
      }
    },
    okHandler: function(bvModalEvt) {
      bvModalEvt.preventDefault();
      console.log('resolving');
      const duplicateIds = Object.keys(this.duplicatesToSend)
      if (!duplicateIds) {
        // TODO: Don't do anything and just close modal or show a warning message?
      }

      // Then loop through checked duplicates.
      duplicateIds
        .filter(key => this.duplicatesToSend[key] === true)
        .map(item => {
          return {
            vm: this,
            duplicate: {
              id: item,
              isResolved: true,
            }
          };
        }
      )
      .forEach((item) => {
        this.$store.dispatch('updateDuplicate', item);
      });
      this.closeModal();
    },
    closeModal: async function() {
      await this.$nextTick();
      this.$store.dispatch('clearUserState');
      this.duplicatesToSend = {}; // reset
      this.$bvModal.hide(this.modalId);
    },
    phoneNum(phoneNumStr) {
      return transformPhoneNum(phoneNumStr);
    }
  },
}
</script>


<style lang="scss">

.duplicate-modal {
  small {
    display: block;
    font-size: 10px;
  }

  .loading-status {
    position: absolute;
    top: -36px;
    right: 0;
  }
}

</style>
